import { render } from "./MemberBenefits.vue?vue&type=template&id=1fc6d772"
import script from "./MemberBenefits.vue?vue&type=script&lang=js"
export * from "./MemberBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__